import _get from "lodash/get";
import styled from 'styled-components';
import { Link } from 'gatsby';
import typographyTheme from '../styles/typographyTheme';
var GatsbyLink = styled(Link).withConfig({
  displayName: "GatsbyLink",
  componentId: "ql7s5o-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme,
      $colorValue = _ref.$colorValue;
  return $colorValue ? _get(theme, "typography.colors." + $colorValue, typographyTheme.typography.colors[$colorValue]) : _get(theme, 'typography.link.color', typographyTheme.typography.link.color);
});
export default GatsbyLink;